import { Box, SimpleGrid} from "@chakra-ui/react";
import React, { useEffect, useState,useRef } from 'react';
import ArticleActionsDetail from "./components/ArticleActionsDetail";
import { useParams } from 'react-router-dom';
import { getArticleStepDetail } from "api/cartableservice";

const ArticleActions = () => 
{
    const { id } = useParams(); 
    const [data, setData] = useState(null);
    const cartableRef = useRef();
  
    useEffect(() => {            

   
         getArticleStepDetail(id)
        .then((data) => {
            setData(data.data || {});
        })
        .catch((err) => console.error("Error fetching article:", err));
    }, [id]);
    if (!data) return <p>Loading...</p>;
    
    return (                         

        <Box pt={{ base: "5px", md: "5px", xl: "5px" }}>
            <SimpleGrid>
                <ArticleActionsDetail data={data} cartableRef={cartableRef} />
            </SimpleGrid>
        </Box>
      
    );

};
  
export default ArticleActions;
  

